import cn from 'classnames';

export const classes = {
  additionalDocumentAdd: cn(
    'odin-bg-white ',
    'odin-border-gray-600 odin-border-dashed odin-border-[1.5px] odin-rounded-sm',
    'odin-cursor-pointer odin-p-3 odin-text-lg odin-text-center',
  ),
};
